import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "../i18n/I18nContext";
import { createProfile } from "../services/profile";
import PermissionGroupsField from "./shared/PermissionGroupsField";

const CriarPerfilLayer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [description, setDescription] = useState("");
  const [permissions, setPermissions] = useState([]);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!description.trim()) {
      toast.error(t("perfis.error.nameRequired"));
      return;
    }
    setSaving(true);
    try {
      await createProfile({ description: description.trim(), permissions });
      toast.success(t("perfis.success.created"));
      navigate("/utilizadores/perfis");
    } catch (err) {
      toast.error(t("perfis.error.save"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className='row gy-4'>
      <ToastContainer />
      <div className='col-12'>
        <div className='card radius-12'>
          <div className='card-body'>
            <div className='row gy-3'>
              <div className='col-sm-6'>
                <label className='form-label'>{t("perfis.field.name")}</label>
                <div className="icon-field">
                  <span className="icon">
                    <Icon icon="f7:person" />
                  </span>
                  <input
                    type='text'
                    className='form-control'
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder={t("perfis.field.name.placeholder")}
                  />
                </div>
              </div>
              <div className='col-12'>
                <label className='form-label'>{t("perfis.field.permissions")}</label>
                <PermissionGroupsField selectedCodes={permissions} onChange={setPermissions} />
              </div>
            </div>
            <div className='d-flex justify-content-end gap-2 mt-24'>
              <button type='button' className='btn btn-outline-secondary' onClick={() => navigate("/utilizadores/perfis")}>
                {t("global.cancel")}
              </button>
              <button type='button' className='btn btn-primary-600' onClick={handleSave} disabled={saving}>
                {saving ? t("global.loading") : <><i className='ri-save-line' /> {t("global.save")}</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CriarPerfilLayer;
